// 可以在此修改项目部分设置
const ajaxBaseUrl = '/mingdao'

export default {
  ajaxBaseUrl,
  companyName: {
    full: {
      eng: 'American Credit, Inc'.toUpperCase(),
      chn: 'American Credit, Inc'
    },
    shortcut: {
      eng: 'American Credit, Inc',
      chn: 'American Credit, Inc'
    }
  },
  imageSrcPrefix: `${ajaxBaseUrl}/platform/system/sysFile/getFileById.ht?fileId=`,
  contractImageSrc: `${ajaxBaseUrl}/mobile/item/pdfSignatureController/readContract.ht?identify=`,
  declarationImageSrc: `${ajaxBaseUrl}/mobile/item/pdfSignatureController/readDeclaration.ht?identify=`
}



// WEBPACK FOOTER //
// ./src/config.js